/**
 * @fileoverview A component which renders actions in the file tree in a button style.
 *
 * @author Justin Mancusi (jmancusi@yext.com)
 */

import {TreeNodeShape} from '/src/com/yext/sitesgitstorm/js/src/editor/tree/nodes/shapesJsDoc';

/**
 * @param {{
 *   node: !TreeNodeShape,
 *   onAddOrUploadFiles: (function(string) | undefined),
 *   onDeleteFile: (function(TreeNodeShape) | undefined),
 *   onDeleteDirectory: (function(string) | undefined),
 *   onRenameFile: (function(TreeNodeShape) | undefined),
 * }} props
 * @return {React.ReactNode}
 */
export const ButtonActions = ({
  node,
  onAddOrUploadFiles,
  onRenameFile,
  onDeleteFile,
  onDeleteDirectory,
}) => {
  if (node.type === 'tree') {
    return <React.Fragment>
      {onAddOrUploadFiles
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      && <i
        className="icon-asset"
        onClick={e => {
          e.stopPropagation();
          onAddOrUploadFiles(node.id);
        }}
      />}
      {onDeleteDirectory
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      && <i
        className="icon-delete"
        onClick={e => {
          e.stopPropagation();
          onDeleteDirectory(node.id);
        }}
      />}
    </React.Fragment>;
  }

  if (node.type === 'blob') {
    return <React.Fragment>
      {onDeleteFile
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      && <i
        className="icon-delete"
        onClick={e => {
          e.stopPropagation();
          onDeleteFile(node);
        }}
      />}
      {onRenameFile
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      && <i
        className="icon-edit"
        onClick={e => {
          e.stopPropagation();
          onRenameFile(node);
        }}
      />}
    </React.Fragment>;
  }

  return null;
};
